// Default that makes a missing `setAppName` call visible in tracking/API logs.
export const DEFAULT_APP_NAME = "web_unknown";
